import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
// const backendUrl="http://localhost:3001/";

export const getData = async () => {
    try{
    let response = await axios.get(backendUrl+"data");
    return response.data;
    }catch(error){
        if(error.response && error.response.status ===404){
            console.log("Resource not found");
        }
        else{
            console.log("Something went wrong "+ error.message);
        }
        return []
    }
}
export const getAbout = async () => {
    try{
    let response = await axios.post(backendUrl+"about");
    return response.data;
    }catch(error){
        if(error.response && error.response.status ===404){
            console.log("Resource not found");
        }
        else{
            console.log("Something went wrong "+ error.message);
        }
        return []
    }
}
export const getProjects = async () =>{
    try{
        let response = await axios.post(backendUrl+"projects");
        return response.data;
    }catch(error){
        if(error.response && error.response.status ===404){
            console.log("Resource not found");
        }
        else{
            console.log("Something went wrong "+ error.message);
        }
        return []
    }
}
export const getProducts = async () =>{
    try{
        let response = await axios.post(backendUrl+"products");
        return response.data;
    }catch(error){
        if(error.response && error.response.status ===404){
            console.log("Resource not found");
        }
        else{
            console.log("Something went wrong "+ error.message);
        }
        return []
    }
}
export const getWorkedWith = async () =>{
    try{
        let response = await axios.post(backendUrl+"worked_with");
        return response.data;
    }catch(error){
        if(error.response && error.response.status ===404){
            console.log("Resource not found");
        }
        else{
            console.log("Something went wrong "+ error.message);
        }
        return []
    }
}
export const getSocialMedia = async () =>{
    try{
        let response = await axios.post(backendUrl+"social_media");
        return response.data;
    }catch(error){
        if(error.response && error.response.status ===404){
            console.log("Resource not found");
        }
        else{
            console.log("Something went wrong "+ error.message);
        }
        return []
    }
}
export const sendConnectDatatoBackend = async (formData) => {
    try {
      const response = await axios.post(backendUrl+'contact', formData); 
      return response.data;
    } catch (error) {
      console.error('Error sending contact form data:', error);
    }
  };

export const verifyAdminStatus = async (idToken) => {
    try {
        const response = await axios.post(backendUrl + 'verify-admin', { token: idToken });
        return response.data.isAdmin; // Expecting { isAdmin: true/false }
    } catch (error) {
        console.error('Admin verification failed:', error);
        return false;
    }
}

export const saveAdminItem = async (collection, item, idToken) => {
    try {
        const response = await axios.post(backendUrl + 'admin/update-item', { collection, item }, {
            headers: { Authorization: `Bearer ${idToken}` }
        });
        return response.data;
    } catch (error) {
        console.error(`Error saving ${collection}:`, error);
        throw error;
    }
}

export const deleteAdminItem = async (collection, id, idToken) => {
    try {
        const response = await axios.post(backendUrl + 'admin/delete-item', { collection, id }, {
            headers: { Authorization: `Bearer ${idToken}` }
        });
        return response.data;
    } catch (error) {
        console.error(`Error deleting ${collection}:`, error);
        throw error;
    }
}
  